import api from '@/api'

export default {
    isWeixinBrowser (){
        if (!window.navigator) return false
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            return true;
        }else{
            return false;
        }
    },
    wechatAuth() {
        var url = process.env.VUE_APP_API_BASE_URL + "/Orchard.Rccl.Users/WechatAuth/MobileCallbackHP?callback="
            + encodeURIComponent(process.env.VUE_APP_BASE_URL+'/Orchard.Rccl.Users/Auth/Wechat?returnUrl=' + encodeURIComponent(location.href));
        window.location.href = "https://mobile.rcclchina.com.cn/wechatplatformapi/WechatApi/oauth2?tenantId=1&scope=snsapi_userinfo&redirect_uri="
            + encodeURIComponent(url);
    },
    tuiWechatAuth() {
        var url = process.env.VUE_APP_BASE_URL+'/Orchard.Rccl.Users/Auth/Wechat?isTui=true&returnUrl=' + encodeURIComponent(location.href);
        window.location.href = "https://mobile.rcclchina.com.cn/wechatadminTUI/WechatApi/oauth2?tenantId=5&scope=snsapi_base&redirect_uri="
            + encodeURIComponent(url);
    },
    async wechatSdkConfig () {
        if (!window.wx) {
            return
        }
        const { data } = await api.page.getWechatSignature()
        if (!data) {
            return
        }
        window.wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'chooseWXPay',
                'showAllNonBaseMenuItem',
                'hideAllNonBaseMenuItem'
            ]
        })
        window.wx.ready(()=>{
            window.wx.showAllNonBaseMenuItem()
            this.wechatShareConfig()
        })
    },
    wechatShareConfig(title, desc, link, imgUrl) {

        if (window.wx) {
            title = title && title.length > 0 ? title: '皇家加勒比国际游轮-中国官方网站'
            desc = desc && desc.length > 0 ? desc: '皇家加勒比国际游轮-中国官方网站'
            link = link && link.length > 0 ? link: "https://mobile.rcclchina.com.cn/"
            imgUrl = imgUrl && imgUrl.length > 0 ? imgUrl: 'https://resource.rcclchina.com.cn/logo/MB/logoWeChatShare.png'
            // console.log(title, desc, link, imgUrl)
            //分享给朋友
            window.wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                success: function () {

                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });

            //分享给朋友圈
            window.wx.onMenuShareTimeline({
                title: desc, // 分享标题
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                success: function () {

                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        }
    }

}
